import { WhatsappIUnlockModal } from "features/Integration/modules/WhatsappIUnlockModal/WhatsappIUnlockModal";
import React from "react";
import LockIcon from "@material-ui/icons/Lock";
import {
  INTEGRATION_LOCK_CHIP_CLASS,
  INTEGRATION_LOCK_ICON_CLASS,
} from "features/Integration/modules/IntegrationCard/constants/integrationLockChip.constants";
import { useWhatsappLock } from "features/Integration/modules/IntegrationCard/hooks/useWhatsappLock";

/**
 * @typedef {Object} WhatsappLockProps
 * @property {string} [lockType]
 * @property {boolean} [whitelabelModalOpen]
 * @property {() => void} [onWhitelabelModalClose]
 * @property {() => void} [onRequestOpenWhitelabelModal]
 */

/**
 * Whitelabel / omnichannel lock chip. Props optional — uncontrolled mode uses internal modal state (e.g. PaymentLinks).
 * @param {WhatsappLockProps} [props]
 */
export const WhatsappLock = (props = {}) => {
  const {
    effectiveWhitelabelOpen,
    handleChipClick,
    handleCloseWhitelabelModal,
    mountWhitelabelUnlockModal,
  } = useWhatsappLock(props);

  return (
    <>
      <div
        id="WhitelabelLock"
        onClick={handleChipClick}
        className={INTEGRATION_LOCK_CHIP_CLASS}
      >
        <LockIcon className={INTEGRATION_LOCK_ICON_CLASS} />
        <div className="tw-ml-2">Locked</div>
      </div>

      {mountWhitelabelUnlockModal && (
        <WhatsappIUnlockModal
          open={effectiveWhitelabelOpen}
          onClose={handleCloseWhitelabelModal}
        />
      )}
    </>
  );
};
